// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card__custom{padding:1rem;border:1px solid rgba(122,123,151,.3)}.card__title{display:flex;flex-direction:row;justify-content:space-between}.icon__xmark{cursor:pointer}", ""]);
// Exports
module.exports = exports;
